{
  "register-personal-data-page": {
    "buttons": {
      "next": "Next",
      "to-login": "To login"
    },
    "text": {
      "title": "Đăng ký",
      "subtitle": "Đăng ký tài khoản mới của bạn",
      "have-account-question": "Bạn đã có tài khoản?",
      "personal-info": "Thông tin cá nhân của bạn",
      "personal-info-hint": "Vui lòng nhập thông tin chi tiết của bạn"
    }
  }
}
